const organizations = {
    title: 'Organizacje',
    description: 'Twórz organizacje i zarządzaj tymi, do których należysz.',
    create: 'Utwórz organizację',
    create_title: 'Utwórz nową organizację',
    name: 'Nazwa organizacji',
    avatar: 'Awatar organizacji',
    avatar_removed: 'Usunięto awatar organizacji.',
    description_label: 'Opis',
    empty: 'Nie należysz jeszcze do żadnej organizacji.',
    pending_invitations: 'Oczekujące zaproszenia',
    accept: 'Zaakceptuj',
    decline: 'Odrzuć',
    owner: 'Właściciel',
    tabs: {
        overview: 'Przegląd',
        members: 'Członkowie',
        invitations: 'Zaproszenia',
        roles: 'Role zarządzania',
        branding: 'Wygląd marki',
        security: 'Bezpieczeństwo',
        jit: 'Aprowizacja JIT',
        applications: 'Udostępnione zasoby',
        activity: 'Aktywność',
        deletion: 'Usuń',
    },
    members: {
        title: 'Członkowie',
        empty: 'Nie znaleziono członków.',
        remove: 'Usuń',
        removed: 'Usunięto członka.',
        business_roles: 'Role biznesowe',
        no_business_roles: 'Brak dostępnych ról biznesowych. Poproś administratora tenanta o udostępnienie ról tej organizacji.',
    },
    invitations: {
        title: 'Zaproszenia',
        invite: 'Zaproś członka',
        email: 'Adres e-mail',
        empty: 'Nie znaleziono zaproszeń.',
        resend: 'Wyślij ponownie',
        resent: 'Zaproszenie wysłano ponownie.',
        revoke: 'Cofnij',
        revoked: 'Cofnięto zaproszenie.',
        status: {
            Pending: 'Oczekujące',
            Accepted: 'Zaakceptowane',
            Expired: 'Wygasłe',
            Revoked: 'Cofnięte',
            Declined: 'Odrzucone',
        },
    },
    roles: {
        title: 'Role zarządzania',
        create: 'Utwórz rolę',
        permissions: 'Uprawnienia',
        empty: 'Nie znaleziono ról zarządzania.',
        select_member: 'Wybierz członka',
        select_role: 'Wybierz rolę',
        assign: 'Przypisz rolę',
        assigned: 'Przypisano rolę.',
        unassign: 'Odbierz rolę',
        unassigned: 'Odebrano rolę.',
        permission_count: 'Uprawnienia: {{count}}',
        built_in: {
            owner: 'Właściciel',
            owner_description: 'Właściciele mają wyłączne uprawnienia do zarządzania własnością i usuwania organizacji.',
            administrator: 'Administrator',
            administrator_description: 'Zarządza organizacją z wyjątkiem działań zastrzeżonych dla właścicieli.',
        },
        permission_labels: {
            update_profile: 'Aktualizacja profilu',
            manage_branding: 'Zarządzanie wyglądem marki',
            view_members: 'Wyświetlanie członków',
            manage_members: 'Zarządzanie członkami',
            manage_invitations: 'Zarządzanie zaproszeniami',
            assign_business_roles: 'Przypisywanie ról biznesowych',
            manage_management_roles: 'Zarządzanie rolami zarządzania',
            assign_management_roles: 'Przypisywanie ról zarządzania',
            manage_security: 'Zarządzanie bezpieczeństwem',
            manage_jit: 'Zarządzanie aprowizacją JIT',
            manage_applications: 'Zarządzanie aplikacjami',
            view_activity: 'Wyświetlanie aktywności',
        },
    },
    branding: {
        title: 'Wygląd marki organizacji',
        primary_color: 'Kolor główny',
        custom_css: 'Własny CSS',
        preview: 'Podgląd',
        light: 'Jasny',
        dark: 'Ciemny',
    },
    security: {
        title: 'Bezpieczeństwo organizacji',
        require_mfa: 'Wymagaj uwierzytelniania wieloskładnikowego od członków',
    },
    jit: {
        title: 'Domeny e-mail JIT',
        domain: 'Domena e-mail',
        add: 'Dodaj domenę',
        verify: 'Sprawdź DNS',
        dns_instruction: 'Utwórz rekord TXT {{record}} z wartością {{value}}.',
        verified: 'Zweryfikowano',
    },
    applications: {
        title: 'Udostępnione zasoby',
        empty: 'Brak dostępnych zasobów dla tej organizacji.',
        sso: 'Firmowe połączenia SSO',
        m2m: 'Aplikacje maszyna-maszyna',
    },
    activity: {
        title: 'Aktywność organizacji',
        empty: 'Brak aktywności.',
        events: {
            create: 'Utworzono organizację',
            delete: 'Usunięto organizację',
            profile: 'Zaktualizowano profil organizacji',
            branding: 'Zaktualizowano wygląd marki',
            security: 'Zaktualizowano bezpieczeństwo organizacji',
            member_add: 'Dodano członka',
            member_remove: 'Usunięto członka',
            owner: 'Zmieniono własność organizacji',
            role_create: 'Utworzono rolę zarządzania',
            role_update: 'Zaktualizowano rolę zarządzania',
            role_delete: 'Usunięto rolę zarządzania',
            role_assign: 'Przypisano rolę zarządzania',
            role_unassign: 'Odebrano członkowi rolę zarządzania',
            business_role: 'Zaktualizowano role biznesowe',
            invitation_create: 'Wysłano zaproszenie',
            invitation_accept: 'Zaakceptowano zaproszenie',
            invitation_decline: 'Odrzucono zaproszenie',
            invitation_revoke: 'Cofnięto zaproszenie',
            jit: 'Zaktualizowano aprowizację JIT',
            domain: 'Weryfikacja domeny e-mail',
            application: 'Zaktualizowano połączenia aplikacji',
            unknown: 'Aktywność organizacji',
        },
    },
    save: 'Zapisz zmiany',
    cancel: 'Anuluj',
    delete: 'Usuń organizację',
    delete_confirmation: 'Organizacja i powiązania jej członków zostaną trwale usunięte. Wpisz „{{name}}”, aby potwierdzić.',
    deleted: 'Usunięto organizację.',
    load_failed: 'Nie udało się wczytać danych organizacji. Spróbuj ponownie.',
    permission_denied: 'Nie masz uprawnień do wyświetlania tej sekcji.',
};
export default organizations;
